import React from 'react';

export default function Loading () {
  return (
    <div className='module_loading_w'>
      <div key={1} className='loading1' />
      <div key={2} className='loading2' />
      <div key={3} className='loading3' />
    </div>
  );
}
